import { QueryClientProvider } from "@tanstack/react-query";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";

// query client
import {
  queryClient,
  queryClientPersister,
  // subQueryClientPersister,
  subscriptionQueryClient,
} from "./query-client";

export function ReactQueryProvider({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element {
  // console.log("buster", import.meta.env.REACT_APP_RELEASE);
  return (
    <QueryClientProvider client={subscriptionQueryClient}>
      {/* DONT ENABLE THIS SUBSCRIPTION PERSISTER YET */}
      {/* <PersistQueryClientProvider
      client={subscriptionQueryClient}
      persistOptions={{
        persister: subQueryClientPersister,
        buster: import.meta.env.REACT_APP_RELEASE,
      }}
    > */}
      <PersistQueryClientProvider
        client={queryClient}
        persistOptions={{
          persister: queryClientPersister,
          buster: import.meta.env.REACT_APP_RELEASE,
        }}
      >
        {children}
      </PersistQueryClientProvider>
      {/* </PersistQueryClientProvider> */}
    </QueryClientProvider>
  );
}
